export default __webpack_public_path__ + "media/privacyoptions.17269f1b.svg";